<template>
    <div v-if="display">
        <preloader class="loader loader-big" :display="display"> </preloader>
        <div v-if="showMessage" class="fallback-message">
            <p>{{ errorMessage }}</p>
            <a :href="fallbackLink">{{ fallbackText }}</a>
        </div>
    </div>
</template>

<script>
import Preloader from './Preloader.vue';

export default {
    props: {
        errorMessage: {
            type: String,
            required: true,
        },
        fallbackText: {
            type: String,
            required: true,
        },
        fallbackLink: {
            type: String,
            required: true,
        },
        display: {
            type: Boolean,
            required: true,
        },
    },
    components: {
        Preloader,
    },
    data() {
        return {
            showMessage: false,
        };
    },
    created() {
        this.runLoader();
    },
    methods: {
        runLoader() {
            setTimeout(() => {
                this.showMessage = true;
            }, 20000);
        },
    },
};
</script>

<style scoped>
.preloader {
    position: fixed;
}
.loader {
    z-index: 1;
}
.fallback-message {
    font-size: 14px;
    font-weight: bold;
    text-align: center;
    position: absolute;
    top: 55%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 1;
}
</style>
